








import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Inventory extends Vue {
  @Prop({ default: false }) readonly active!: boolean;
}
